import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { system as styledSystem } from '@styled-system/core';

import './UPAdminDropdownButton.less';

const UPAdminDropdownButton = ({
  title,
  options,
  className,
  onClickTitle,
  onClickOption,
  ..._styles
}) => {
  const styledParser = styledSystem({
    minWidth: true,
    maxWidth: true,
  });

  const styles = styledParser(_styles);

  return (
    <div
      className="adminDropdownButton"
      styleName={classNames('adminDropdownButton', className)}
      style={styles}
    >
      <div styleName="container">
        <span styleName="mainAction" onClick={onClickTitle}>
          {title}
        </span>
        <div styleName="arrowDropDown" />
        <div styleName="dropdown">
          {options.map((option) => (
            <span
              key={`${option.value}`}
              styleName={classNames('option', { selected: option.selected })}
              onClick={() => onClickOption(option.value)}
            >
              {option.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

UPAdminDropdownButton.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
  onClickOption: PropTypes.func.isRequired,
  onClickTitle: PropTypes.func,
};

UPAdminDropdownButton.displayName = 'UPAdminDropdownButton';

export default UPAdminDropdownButton;
